import { scopeGroups } from "@/mocks/civicData";

const toneMap: Record<string, string> = {
  primary: "text-primary-600 border-primary-200 bg-primary-50",
  accent: "text-accent-600 border-accent-200 bg-accent-50",
  secondary: "text-secondary-600 border-secondary-200 bg-secondary-50",
};

export default function Scope() {
  return (
    <section id="scope" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
            <span className="h-px w-8 bg-primary-400"></span>
            常见的反映范围
            <span className="h-px w-8 bg-primary-400"></span>
          </p>
          <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            哪些身边情况值得关注
          </h2>
          <p className="mt-4 text-base leading-8 text-foreground-600">
            以下仅作常见类型示意，具体受理口径请以属地官方渠道说明为准。
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          {scopeGroups.map((g) => (
            <div
              key={g.title}
              className="rounded-2xl border border-background-200 bg-background-100 p-7"
            >
              <div className="flex items-center gap-3">
                <span
                  className={`flex h-10 w-10 items-center justify-center rounded-full border text-lg ${toneMap[g.tone]}`}
                >
                  <i className="ri-shield-star-line"></i>
                </span>
                <h3 className="font-heading text-xl font-bold text-foreground-950">
                  {g.title}
                </h3>
              </div>
              <ul className="mt-6 grid gap-3 sm:grid-cols-2">
                {g.items.map((item) => (
                  <li
                    key={item}
                    className="flex items-start gap-2 text-sm text-foreground-700"
                  >
                    <i className="ri-checkbox-circle-line mt-0.5 text-secondary-500"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}